class ErrorHandler {
    /**
     * Logs errors with various severity levels. Capable of integrating with external monitoring services.
     * Also logs to console in non-production environments for easier debugging.
     * @param {Error | string} error - The error object or message to be logged.
     * @param {'info' | 'warn' | 'error'} level - The severity level of the error.
     */
    static logError(error: Error | string, level: 'info' | 'warn' | 'error' = 'error'): void {
        const message = typeof error === 'string' ? error : error.message;

        // Log to console in non-production environments
        if (process.env.NODE_ENV !== 'production') {
            console[level](message);
            if (error instanceof Error && error.stack) console[level](error.stack);
        }
    }
}

export default ErrorHandler;